import { create, retrieve, retrieveCollection, update } from "framework/http/endpoint";
import { createCollectionResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate, intoApiTransportDateTimeOffset } from "framework/http/transport";
import { PartnershipRegistrationState } from "./entity";
import { createCollectionRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/competitors/couple_or_duo_registrations");
function intoTransportPartnership(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.fromDate = intoApiTransportDateTimeOffset(entity.fromDate);
    return result;
}
function fromTransportPartnership(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.registrationDate = fromApiTransportDate(entity.registrationDate);
    result.separationDate = fromApiTransportDate(entity.separationDate);
    result.person1.confirmationDate = fromApiTransportDate(entity.person1.confirmationDate);
    result.person2.confirmationDate = fromApiTransportDate(entity.person2.confirmationDate);
    return result;
}
function loadListOfPartnerships(parameters) {
    var uri = "".concat(ApiUriPrefix, "?").concat(Object.keys(parameters).map(function (k) { return "".concat(k, "=").concat(parameters[k]); }).join("&"));
    return retrieveCollection(uri, null, null, createCollectionResponseFactory(fromTransportPartnership));
}
function apiGetCompetitorPartnerships(competitorId) {
    var uri = "".concat(ApiUriPrefix, "?filter=competitorId=").concat(competitorId);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportPartnership));
}
function apiGetAthletePartnerships(idt) {
    var uri = "".concat(ApiUriPrefix, "?filter=idt=").concat(idt);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportPartnership));
}
function apiGetAthletePartnership(id) {
    var uri = "".concat(ApiUriPrefix, "?filter=id=").concat(id);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportPartnership));
}
function apiUpdatePartnershipState(id, state, idt1, idt2, dateOfTermination) {
    if (dateOfTermination === void 0) { dateOfTermination = null; }
    var uri = "".concat(ApiUriPrefix, "/status");
    var data = {
        registrationId: id,
        state: state,
        idt1: idt1,
        idt2: idt2,
    };
    if (state === PartnershipRegistrationState.Separated && dateOfTermination !== null) {
        data.fromDate = dateOfTermination;
    }
    var transport = intoTransportPartnership(data);
    var request = createCollectionRequest([transport]);
    return update(uri, request, createCollectionResponseFactory(fromTransportPartnership));
}
function apiCreatePartnership(partnershipData) {
    var uri = ApiUriPrefix;
    partnershipData.forEach(function (d) { d = intoTransportPartnership(d); });
    var request = createCollectionRequest(partnershipData);
    return create(uri, request, createCollectionResponseFactory(fromTransportPartnership));
}
export { loadListOfPartnerships, apiGetAthletePartnerships, apiGetCompetitorPartnerships, apiGetAthletePartnership, apiUpdatePartnershipState, apiCreatePartnership, };
